import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import ReactDOM from 'react-dom';
import FullscreenWrapper from '../fullscreen/fullscreenWrapper';
import { makeEventListener } from '../hooks/eventListener';
export const WixProGalleryWithFullscreen = WixProGallery => props => {
  const [fullscreenIdx, setFullscreenIdx] = React.useState(-1);
  const eventsListener = makeEventListener().ITEM_ACTION_TRIGGERED(_ref => {
    let {
      idx
    } = _ref;
    if (props.enableFullscreen) {
      setFullscreenIdx(idx);
    }
  }).done(props.eventsListener);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WixProGallery, _extends({}, props, {
    eventsListener: eventsListener
  }), fullscreenIdx !== -1 && props.enableFullscreen && /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(FullscreenWrapper, {
    deviceType: props.deviceType,
    options: props.fullscreenOptions,
    setFullscreenIdx: setFullscreenIdx,
    fullscreenIdx: fullscreenIdx,
    items: props.items,
    viewMode: props.viewMode
  }), document.body), props.children));
};
//# sourceMappingURL=withFullscreen.js.map